export default __webpack_public_path__ + "static/joshua-b93da965a5268323a63c49530c2c2b21.png";